import React from 'react';
import { useEffect } from "react";
import { useState } from 'react';
import axios from "axios";
import { useNavigate } from 'react-router-dom';


// import Dropdown from 'react-bootstrap/Dropdown';
// import DropdownButton from 'react-bootstrap/DropdownButton';
// import Button from 'react-bootstrap/Button';

// import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';

// import BallotInterface from "../interfaces/ballotInterface";
import PostShowResponseInterface from "../interfaces/postShowResponseInterface";
import { stringify } from 'querystring';

//import { BallotContext } from "../context/BallotContext";

import Cookies from "js-cookie";
import { v4 as uuid } from "uuid";


export default function PostshowQuestions() {

  const queryParameters = new URLSearchParams(window.location.search)
  const sID = queryParameters.get("showID") ?? "undefined"

  // Get (or create) unique ID for this patron
  const [userID2, setUserID2] = useState("initializing");
  if (userID2 == "initializing") {
    const c = Cookies.get("UserID2");
    if (c == null) {
      // generate  unique random identifier
      const unique_id = uuid();
      Cookies.set("UserID2", unique_id, { expires: 7, path: "/" });
      setUserID2(unique_id);
    } else {
      setUserID2(c);
    }
  }

//  const { currentBallot, setCurrentBallot } = React.useContext(BallotContext);

  const navigate = useNavigate();

  // This submits just the wild prediction. How do we submit all the elements of the form as JSON?
  // maybe:
  // https://www.google.com/search?q=how+to+submit+a+react+form+as+json&oq=how+to+submit+a+react+form+as+json&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIHCAEQIRigATIHCAIQIRigATIHCAMQIRigATIHCAQQIRigATIHCAUQIRigATIHCAYQIRifBTIHCAcQIRifBTIHCAgQIRifBTIHCAkQIRifBdIBCDY2ODlqMGo3qAIAsAIA&sourceid=chrome&ie=UTF-8#ip=1
  //
  function submitForm(techcontrol,wildprediction) {

    const postShowResponse: PostShowResponseInterface = { showID: sID, techControl: techcontrol, wildPrediction: wildprediction, userID2: userID2 };
    console.log("Submitting response: " + postShowResponse)

    axios
    .post<PostShowResponseInterface>(process.env.REACT_APP_HOST + "/postshowresponse", postShowResponse)
    .then((response) => {
      console.log(response.status)
      navigate('/thankyou') // Send them to the thankyou page
//      setCurrentBallot(response.data);
    })
    .catch((ex) => {
      const error = "An unexpected error has occurred. Could not submit response: " + ex;
      console.log(error)
    });
    //addVotedIDToStorage(currentBallot.id);
    //setUserInputData('')
    console.log("Submitted response") // will it ever get here? I think so
  }

  useEffect(() => {
    document.title = "DxD Postshow Questions";
  }, []);

  const [radioValue, setRadioValue] = useState('1');

  const [techcontrol, setTechcontrol] = useState('');
  const [wildprediction, setWildprediction] = useState('');
  const [error, setError] = useState('');
  const [status, setStatus] = useState('typing');

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus('submitting');
    try {
      await submitForm(techcontrol,wildprediction);
      setStatus('success');
    } catch (err) {
      setStatus('typing');
      setError('err');
    }
  }

  const handleChange = (val) => {
    setTechcontrol(val); 
    console.log(val);
  }

  function handleTextareaChange(e) {
    setWildprediction(e.target.value);
  }

  return (
    <>
      <p>After reflecting on the performance, how much do you control your technology and how much does it control you?
:</p>
      
      <form onSubmit={handleSubmit}>
        <p>
          How much do you control your technology and how much does it control you?
        </p>
        
        {/*
        <ToggleButtonGroup type="radio" name="options" value={techcontrol} onChange={handleChange}>
          <ToggleButton value="1">Option 1</ToggleButton>
          <ToggleButton value="2">Option 2</ToggleButton>
          <ToggleButton value="3">Option 3</ToggleButton>
       </ToggleButtonGroup>
       */}

<ToggleButtonGroup type="radio" name="options" value={techcontrol} onChange={handleChange}>
          <ToggleButton id="tg1" value="1">
            <label htmlFor="tg1">I control technology a lot</label><br />
          </ToggleButton>
          <ToggleButton id="tg2" value="2">
            <label htmlFor="tg2">I am generally in control of my technology</label><br />
          </ToggleButton>
          <ToggleButton id="tg3" value="3">
          <label htmlFor="tg3">Technology is generally in control of me</label><br />
          </ToggleButton>
          <ToggleButton id="tg4" value="4">
          <label htmlFor="tg4">Technology controls me a lot<br /></label>
          </ToggleButton>
        </ToggleButtonGroup>

        <br />
        <p>
        What themes around our relationship to technology did this performance invite you to think about?
        </p>
        <textarea
          rows={5}
          cols={50}
          value={wildprediction}
          onChange={handleTextareaChange}
          disabled={status === 'submitting'}
        />
        <br />

        <button disabled={
          wildprediction.length === 0 ||
          status === 'submitting'
        }>
          Submit
        </button>
        {error !== '' &&
          <p className="Error">
            {error}
          </p>
        }
      </form>

    </>
  );
}

